<template>
  <div class="sticky-top help">
    <div v-if="$store.state.user.check_is_wxc_domain()" class="box mt-3 p-3 bolger-box sticky-top help">
      <span v-html="icons.helpcenter"></span>
      <span class="ml-3 mb-3 "><a href="/help/?id=0" class="title font-weight-bold text-dark">帮助中心</a></span>
<!--      <div class=row>-->
<!--        <div class="col-12 mt-3 text-secondary ghelp">-->
<!--          <a href="/help/?id=0" class="small">文学城群吧相关问题</a>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class=row>-->
<!--        <div class="col-12 mt-3 text-secondary ghelp">-->
<!--          <a href="/help/?id=100" class="small">文学城群吧升级相关</a>-->
<!--        </div>-->
<!--      </div>-->
      <h6 class="sidebar-heading d-flex mt-4 mb-1 text-muted ">
        <span>群主相关</span>
      </h6>
      <div class=row>
        <div class="col-6 mt-1 text-secondary ghelp">
          <a href="/help/?id=0" class="small">如何创建群吧</a>
        </div>
        <div class="col-6 mt-1 text-secondary ghelp">
          <a href="/help/?id=1" class="small">如何管理群吧</a>
        </div>
       </div>
      <div class=row>
        <div class="col-6 mt-1 text-secondary ghelp">
          <a href="/help/?id=11" class="small">如何设置推广</a>
        </div>
        <div class="col-6 mt-1 text-secondary ghelp">
          <a href="/help/?id=2" class="small">如何邀请群员</a>
        </div>
      </div>
      <div class=row>
        <div class="col-6 mt-1 text-secondary ghelp">
          <a href="/help/?id=7" class="small">如何管理群员</a>
        </div>
        <div class="col-6 mt-1 text-secondary ghelp">
            <a href="/help/?id=9" class="small">如何批准群员</a>
        </div>
      </div>
      <div class=row>
        <div class="col-6 mt-1 text-secondary ghelp">
          <a href="/help/?id=3" class="small">如何创建话题</a>
        </div>
        <div class="col-6 mt-1 text-secondary ghelp">
          <a href="/help/?id=12" class="small">话题管理帖子</a>
        </div>
      </div>
      <h6 class="sidebar-heading d-flex mt-4 mb-1 text-muted ">
        <span>常见问题</span>
      </h6>
      <div class=row>
        <div class="col-6 mt-1 text-secondary ghelp">
          <a href="/help/?id=4" class="small">如何加入群吧</a>
        </div>
        <div class="col-6 mt-1 text-secondary ghelp">
          <a href="/help/?id=5" class="small">如何退出群吧</a>
        </div>
      </div>
<!--      <div class=row>-->
<!--        <div class="col-6 mt-1 text-secondary ghelp">-->
<!--          <a href="/help/?id=4" class="small">如何发贴</a>-->
<!--        </div>-->
<!--        <div class="col-6 mt-1 text-secondary ghelp">-->
<!--          <a href="/help/?id=5" class="small">如何编辑</a>-->
<!--        </div>-->
<!--      </div>-->
      <!--    <div class=row>-->
      <!--      <div class="col-6 mt-3  text-secondary">
                    <a href="https://www.haiwai.com/blog/p/1448487" class="small">如何发视频</a>
                </div>-->
      <!--      <div class="col-6 mt-3 text-secondary ghelp


"><a href="https://www.haiwai.com/blog/p/1448488" class="small">如何贴音乐</a></div>-->
      <!--    </div>-->

      <!-- AD side3 -->
      <!--        <div data-aaad='true' data-aa-adunit='/339474670/Haiwai/Side3' class="mt-4"></div>-->
    </div>
    <div v-else class="box mt-3 p-3 bolger-box">
      <!--    <span v-html="icons.helpcenter"></span>-->
      <i class="el-icon-help"></i>
    <span class="ml-1 mb-3">
<!--      <a href="http://beta.haiwai.com/group/list/28?topic=41" class="help-title font-weight-bold text-dark">-->
       <span class="help-title font-weight-bold text-dark">
          帮助中心
       </span>
    </span>
      <div class=row>
        <div class="col-6 mt-1 text-secondary ghelp">
          <a href="/help/?id=0" class="small">如何创建群吧</a>
        </div>
        <div class="col-6 mt-1 text-secondary ghelp">
          <a href="/help/?id=1" class="small">如何管理群吧</a>
        </div>
      </div>
      <div class=row>
        <div class="col-6 mt-1 text-secondary ghelp">
          <a href="/help/?id=2" class="small">如何邀请群员</a>
        </div>
        <div class="col-6 mt-1 text-secondary ghelp">
          <a href="/help/?id=3" class="small">如何使用话题</a></div>
      </div>
      <div class=row>
        <div class="col-6 mt-1 text-secondary ghelp">
          <a href="/help/?id=4" class="small">如何加入群吧</a></div>
        <div class="col-6 mt-1 text-secondary ghelp">
          <a href="/help/?id=5" class="small">如何退出群吧</a></div>
      </div>

      <!--    <div class=row>-->
      <!--      <div class="col-6 mt-3  text-secondary"><a href="https://www.haiwai.com/blog/p/1448487" class="small">如何发视频</a></div>-->
      <!--      <div class="col-6 mt-3 text-secondary ghelp
 

"><a href="https://www.haiwai.com/blog/p/1448488" class="small">如何贴音乐</a></div>-->
      <!--    </div>-->

      <!-- AD side3 -->
      <!--    <div data-aaad='true' data-aa-adunit='/339474670/Haiwai/Side3' class="mt-4"></div>-->
    </div>
    <!-- AD side3 -->
<!--    <div data-aaad='true' style="width: 270px;overflow: hidden" data-aa-adunit='/339474670/Haiwai/Side3' class="ad_marginy"></div>-->
    <customer-service></customer-service>

  </div>

</template>
<script>
import CustomerService from '@/module/user/components/CustomerService.vue';
import icons from "@/components/Icons/Icons";

export default {
  name: 'blog-help',
  components: {
    CustomerService
  },
  methods: {},
  data() {
    return {
      icons: icons,
    };
  },
};
</script>
<style>
#WxcColor .help a.title {
  color: #333;
  font-size: 18px
}

#WxcColor .ghelp {
  padding: 10px 0
}

.help a {
  color: #6c757d;
  font-size: 1rem
}

#WxcColor .help a {
  color: #6c757d;
  font-size: 15px;
}

.help-title {
  font-size: 1.3rem !important;

}

.bolger-box {
  background-color: #f6f9fc;
  border-radius: 16px;
  padding: 18px 0;
  z-index: auto
}

.help i {
  font-size: 28px;
  cursor: pointer;
  vertical-align: top;
}

.user-help i, .user-help .help-title {
  color: #0485b9 !important;
}

.user-help .help-title {
  font-size: 20px !important;
}

/*.sticky-top {*/
/*  position: -webkit-sticky!important;*/
/*  position: sticky!important;*/
/*}*/
</style>
